import type { CreateTweetBodyJsonData } from './createTweetBodyJsonData';

export type CreateTweetBody = {
  jsonData?: CreateTweetBodyJsonData;
  /** 업로드할 미디어 파일들 */
  mediaFiles?: Blob[];
};
